import axios from '../utils/aioxs'
import { domainid } from '@/utils/utils'
import Jons from 'utils/dataset.json'

export function getConfigApi(data) {
  if (!data.domain_id) delete data.domain_id
  let params = {
    application: 'config',
    datasource: 'config_service',
    name: 'all',
    param: {
      ...data,
    },
    query: Jons.config.config_service.all,
  }
  return axios({
    url: '/datapool/mysql?format=row',
    method: 'post',
    data: params,
  })
}

export function getPolicyBaseSimpleApi(data, baseURL) {
  let params = {
    application: 'config',
    datasource: 'config_service',
    name: 'policy_base_simple',
    param: {
      ...data,
    },
    query: Jons.config.config_service.policy_base_simple,
  }
  let query = {
    url: '/datapool/mysql?format=row',
    method: 'post',
    data: params,
  }
  if (baseURL) {
    query.baseURL = baseURL
  }
  return axios(query)
}

// 保存配置
export function updateConfigApi(data) {
  // const { app_application, app_datasource, app_name, ...attrs } = data || {}
  // let params = {
  //   [app_application]: {
  //     [app_datasource]: {
  //       [app_name]: attrs,
  //     },
  //   },
  // }
  return axios({
    url: `/datapool/query_config/import`,
    method: 'post',
    data: data,
  })
}

// 删除应用配置
export function deleteConfigApi(data) {
  return axios({
    method: 'post',
    url: `/datapool/mysql/${domainid()}/config_service/sql_config`,
    data,
  })
}

// 获取所有application
export function getAllApplicationApi() {
  let params = {
    application: 'config',
    datasource: 'config_service',
    name: 'all_application',
    query: Jons.config.config_service.all_application,
  }
  return axios({
    url: '/datapool/mysql?format=row',
    method: 'post',
    data: params,
  })
}
// 获取所有datasource
export function getAllDatasourceApi(data) {
  let params = {
    application: 'config',
    datasource: 'config_service',
    name: 'all_datasource',
    param: {
      ...data,
    },
    query: Jons.config.config_service.all_datasource,
  }
  return axios({
    url: '/datapool/mysql?format=row',
    method: 'post',
    data: params,
  })
}
